export default __webpack_public_path__ + "static/media/resume.43399869.pdf";